import React from 'react';
import PropTypes from 'prop-types';
import Error from '../../General/Error';
import InvoiceServiceErrorIcon from '../../../images/errores/fantasma.svg';

const Load = ({ onClick }) => (
  <>
    <Error
      type="NO PUDIMOS CARGAR TUS BOLETAS"
      text="En estos momentos nuestro servicio está presentando problemas"
      button={{
        text: 'reintentar',
        click: onClick,
        color: 'purple',
        outline: true,
        transparent: false,
      }}
      icon={InvoiceServiceErrorIcon}
    />
  </>
);

Load.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default Load;
